module.exports = __webpack_public_path__ + "static/img/rz_15.ba8818b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/rz_15.jpg
// module id = CRdk
// module chunks = 0